import { useMutation } from '@tanstack/react-query';

export function useSendEmail() {
  return useMutation({
    mutationFn: async (email: string) => {
      const response = await fetch('https://api.paraswap.io/stk/subscriber', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) {
        throw new Error('Failed to send email');
      }
      return response.json();
    },
  });
}
